import { render, staticRenderFns } from "./porticos.vue?vue&type=template&id=1c323621&scoped=true&"
import script from "./porticos.vue?vue&type=script&lang=js&"
export * from "./porticos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c323621",
  null
  
)

export default component.exports